import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { useGLTF } from '@react-three/drei';

function City({ rotationEnabled }) {
  const group = useRef();
  const assetPath = '/scene-draco.glb';
  const { nodes, materials } = useGLTF(assetPath);

  useFrame(() => {
    if (rotationEnabled) {
      group.current.rotation.y += 0.003;
    }
  });

  return (
    <group ref={group} scale={0.001} position={[0, 0, -100]} dispose={null}>
      <group rotation={[-Math.PI / 2, 0, 0]}>
        <group position={[-102253.52, -210688.86, -17050.52]}>
          <mesh
            geometry={nodes.mesh_0.geometry}
            material={materials.Scene_Root}
            material-color="#333333"
          />
          <mesh
            geometry={nodes.mesh_1.geometry}
            material={materials.Scene_Root}
            material-color="#333333"
          />
          <mesh
            geometry={nodes.mesh_2.geometry}
            material={materials.Scene_Root}
            material-color="#333333"
          />
          <mesh
            geometry={nodes.mesh_3.geometry}
            material={materials.Scene_Root}
            material-color="#333333"
          />
        </group>
        
        <mesh position={[250000, -200000, 50000]}>
          <sphereGeometry args={[30000, 32, 32]} />
          <meshBasicMaterial color="#3182CE" />
        </mesh>
      </group>
    </group>
  );
}

useGLTF.preload('/scene-draco.glb');

export default City;